import { useEffect } from 'react';

import { setDeckCardsHydrator } from '../internal/deck-cards-hydrator';
import { useColdDeckActions } from '../use-cold-deck-actions';

/**
 * Hands the provider-bound cold-deck rehydrate to the module-level seam
 * (`internal/deck-cards-hydrator.ts`) for the life of the sync core, so a
 * background write that must read a deck's every card (a batch document
 * landing while the deck is cold — `deck-sources.ts`) can make them resident
 * without a hook. Mounted once by `SyncCore` on both platforms; renders
 * nothing.
 */
export function DeckCardsHydratorRegistrar(): null {
  const { rehydrateColdDeck } = useColdDeckActions();
  useEffect(() => {
    setDeckCardsHydrator((deckId) => rehydrateColdDeck(deckId));
    return () => setDeckCardsHydrator(null);
  }, [rehydrateColdDeck]);
  return null;
}
